// Modules
import { createContext as reactCreateContext, useContext } from "react";
/**
 * Creates a named context, provider, and hook.
 *
 * @param options - create context options.
 */ export function createContext(options = {}) {
    const { strict = true, errorMessage = 'Tempo: `context` is undefined. Seems you forgot to wrap component within the Provider', name } = options;
    const CustomContext = reactCreateContext(undefined);
    CustomContext.displayName = name;
    const useCustomContext = ()=>{
        const context = useContext(CustomContext);
        if (!context && strict) {
            const error = new Error(errorMessage);
            error.name = 'ContextError';
            throw error;
        }
        return context;
    };
    return [
        CustomContext.Provider,
        useCustomContext,
        CustomContext
    ];
}

//# sourceMappingURL=createContext.js.map